module.exports = __webpack_public_path__ + "static/img/66.8a966034.svg";